<template>
  <div class="missions">
    <div class="d-flex justify-space-between">
      <missions-filter :filter="filter" :missionsCount="missionsCount" />
    </div>
    <v-alert v-if="!missionsCount" class="my-2" variant="tonal" type="warning" :text="$t('planning.message.no-rdv')" />
    <v-timeline
        side="end"
        align="start"
        density="compact"
    >
      <v-timeline-item
          v-for="(groupedItems, groupDay) in groupedItemsByDay"
          :key="groupDay"
          :icon="mdiCalendarClock"
          fill-dot
          dot-color="transparent"
          width="100%"
      >
        <div class="text-h7 text-uppercase font-weight-bold my-2 text-blue-grey">{{ groupDay }}</div>
        <div v-for="item in groupedItems" :key="item._type + '-' + item.id">
          <planning-cra-event
              v-if="item._type === 'cra'"
              :craEvent="item"
          />
          <planning-point-of-sale
              v-else
              :class="{'opacity-05': item.to_remove}"
              :missionPlanning="item"
              :pointOfSale="filterPointsOfSaleByMission(item.mission.id)"
              :readingsHistory="filterReadingsHistoryByPos(item.mission.id)"
              :missionMissionsPlannings="getMissionsPlanningsByMission(item)"
              :configuration="configurations[missions[item.mission.id]?.configuration.id]"
          />
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script setup>


import MissionsFilter from './MissionsFilter.vue';
import PlanningPointOfSale from './PlanningPointOfSale.vue';
import PlanningCraEvent from './PlanningCraEvent.vue';
import { computed, reactive } from 'vue';
import { mdiCalendarClock } from '@mdi/js';
import {
  filterMissionsByYearAndWeekDays,
  filterCrasByYearAndWeekDays,
  groupMissionsByWeekDays,
  extractMissionsPlanningsByMission
} from '@/stores/manager/missionManager';
import { filterReadingsByMissions} from '@/stores/manager/readingHistoryManager';
import { useStoreManager } from '@/stores/storeManager';

const props = defineProps({
  planningCras: {
    type: Object,
    required: false,
  },
  missionsPlannings: {
    type: Object,
    required: true,
  },
  missions: {
    type: Object,
    required: true,
  },
  pointOfSales: {
    type: Object,
    required: true,
  },
  readingsHistory: {
    type: Object,
    required: true,
  },
  filter: {
    type: Object,
    required: true,
  },
});

const storeManager = useStoreManager()

const missionsPlanningsWithFinalValidation = computed(() => {
  return Object.fromEntries(
      Object.entries(props.missionsPlannings).filter(([_, value]) => value.state === "3")
  );
});


const missionsPlanningsList = computed(() => {
  return props.filter.selectedWeek.value
    ? filterMissionsByYearAndWeekDays(missionsPlanningsWithFinalValidation.value, props.filter.selectedWeek.value, props.filter.selectedYear)
    : {};
});


const configurations = computed(() =>
  storeManager.getFromStoreByCategory('configuration', 'configurations')
);


const getMissionsPlanningsByMission = computed(() =>
        (missionPlanning) => extractMissionsPlanningsByMission(missionsPlanningsWithFinalValidation.value, [parseInt(missionPlanning.mission.id)])
);


const filteredPlanningCras = computed(() => {
  return props.filter.selectedWeek.value && props.planningCras
    ? filterCrasByYearAndWeekDays(props.planningCras, props.filter.selectedWeek.value)
    : {};
});

const filteredPlanningCrasValues = computed(() => Object.values(filteredPlanningCras.value));

const paginatedMissionsPlannings = computed(() => Object.values(missionsPlanningsList.value));

const groupedItemsByDay = computed(() =>
  groupMissionsByWeekDays(paginatedMissionsPlannings.value, props.filter, filteredPlanningCrasValues.value)
);

const missionsCount = computed(() =>
  Object.values(missionsPlanningsList.value).length
);

function filterReadingsHistoryByPos(missionId) {
  return filterReadingsByMissions(props.readingsHistory, [missionId]);
}

function filterPointsOfSaleByMission(mission) {
  return props.pointOfSales[
    props.missions[mission]?.pos?.id
  ];
}
</script>